import { StoreState as FilterStoreState, createFilterStore } from 'store/filter-store';
import { namespace } from 'vuex-class';

export const assignmentGroupsFilterNS = namespace('shiftSchedule/assignmentGroupsFilter');

export type StoreState = FilterStoreState;

const getStore = () => createFilterStore({ namespaced: true });

export default getStore;
